import type { MouseEvent } from 'react';

const LANDING_HEADER_OFFSET = 72;

export function scrollToSection(sectionId: string): void {
  const el = document.getElementById(sectionId);
  if (!el) return;

  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  const top =
    el.getBoundingClientRect().top + window.scrollY - LANDING_HEADER_OFFSET;

  window.scrollTo({
    top: Math.max(0, top),
    behavior: prefersReducedMotion ? 'auto' : 'smooth',
  });
}

export function handleLandingAnchorClick(
  event: MouseEvent<HTMLAnchorElement>,
  href: string
): void {
  if (!href.startsWith('#')) return;
  const id = href.slice(1);
  if (!id) return;
  event.preventDefault();
  scrollToSection(id);
}
